import { MutableRefObject, ReactNode, createContext, useMemo } from 'react';

type MapEntityDrawerContextType = {
  scrollElementRef: MutableRefObject<Element | undefined> | null;
  closeDrawer: () => void;
};

type DesktopScrollProviderProps = {
  children: ReactNode;
  scrollElementRef: MutableRefObject<Element | undefined>;
  closeDrawer: () => void;
};

type MobileScrollProviderProps = {
  children: ReactNode;
  scrollElementRef: MutableRefObject<Element | undefined>;
  closeDrawer: () => void;
};

export const MapEntityDrawerContext = createContext<MapEntityDrawerContextType>(
  { scrollElementRef: null, closeDrawer: () => {} },
);

export const DesktopScrollProvider = (
  props: DesktopScrollProviderProps,
): JSX.Element => {
  const { children, closeDrawer, scrollElementRef } = props;

  const context = useMemo(
    () => ({
      scrollElementRef,
      closeDrawer,
    }),
    [scrollElementRef, closeDrawer],
  );

  return (
    <MapEntityDrawerContext.Provider value={context}>
      {children}
    </MapEntityDrawerContext.Provider>
  );
};

export const MobileScrollProvider = (
  props: MobileScrollProviderProps,
): JSX.Element => {
  const { scrollElementRef, children, closeDrawer } = props;

  const context = useMemo(
    () => ({
      scrollElementRef,
      closeDrawer,
    }),
    [scrollElementRef, closeDrawer],
  );

  return (
    <MapEntityDrawerContext.Provider value={context}>
      {children}
    </MapEntityDrawerContext.Provider>
  );
};
